/* The strip of tabs under a place or inside a page. One hairline under the row, the current tab
   marked by an accent underline AND heavier text (never colour alone), horizontal scroll rather than
   wrapping so the strip stays one line at any width. */

.strip {
  display: flex;
  flex: 0 0 auto;
  align-items: stretch;
  gap: 2px;
  min-width: 0;
  padding: 0 var(--pad);
  overflow-x: auto;
  background: var(--panel);
  border-bottom: 1px solid var(--line);
  scrollbar-width: none;
}

.strip::-webkit-scrollbar {
  display: none;
}

.item {
  display: inline-flex;
}

.tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  min-height: 40px;
  padding: 0 12px;
  border: 0;
  background: none;
  color: var(--muted);
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  transition: color var(--dur-1) var(--ease-std);
}

.tab:hover {
  color: var(--ink);
}

.tab:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: -2px;
  border-radius: var(--radius-ctl);
}

.tab[data-active="true"] {
  color: var(--ink);
  font-weight: 650;
}

.tab[data-active="true"]::after {
  content: "";
  position: absolute;
  right: 10px;
  bottom: -1px;
  left: 10px;
  height: 2px;
  border-radius: 2px 2px 0 0;
  background: var(--accent);
}

@media (max-width: 560px) {
  .tab {
    min-height: var(--target-touch);
  }
}
